// JS associated with snippets/mr__delivery-validator-modal.liquid

MicroModal.init();

// Whenever an ATC button is clicked, if user's browser hasn't asked for delivery validation before, open the modal
const addToCart = document.querySelectorAll(".button--add-to-cart");
for (let i = 0; i < addToCart.length; i++) {
  const elem = addToCart[i];

  elem.addEventListener("click", function () {
    if (localStorage.getItem("addedToCartAlready") != "yes") {
      MicroModal.show("mr__deliveryValidatorModal");
    }
    localStorage.setItem("addedToCartAlready", "yes");
  });
}

// Whenever the topbar's Learn More link is clicked for delivery validation, open the modal
const topbarLearnMore = document.querySelectorAll(".deliveryValidatorLearnMore");

topbarLearnMore.forEach($el => {
  $el.addEventListener("click", function () {
    MicroModal.show("mr__deliveryValidatorModal");
  })
})

// When the delivery validator modal's form is submitted, use Zapiet API check for delivery eligibility
const deliveryValidatorModalSubmit= document.querySelector('#mr__deliveryValidatorModal main form button');
deliveryValidatorModalSubmit.addEventListener('click', function (event) {
  event.preventDefault();
  MicroModal.close('mr__deliveryValidatorModal');
  const deliveryValidatorZipInputValue = document.querySelector('#mr__deliveryValidatorModal main form input').value;
  validateZipCode(deliveryValidatorZipInputValue);
})

// Check delivery eligibility, and display the appropriate resulting modal
// https://zapiet.freshdesk.com/en/support/solutions/articles/60000602432-delivery-validator-widget-early-access-
function validateZipCode(zipValue) {        
  // Checks to ensure Store Pickup + Delivery is installed correctly
  if (typeof window.Zapiet === 'undefined' || typeof window.ZapietCachedSettings === 'undefined' || 
      typeof window.Zapiet.DeliveryValidator === 'undefined' || window.ZapietCachedSettings.cached_config === 'undefined' || 
      window.ZapietCachedSettings.cached_config.delivery_validator === 'undefined') {
    console.warn('Delivery validator error.'); 
    return false;
  }

  Zapiet.DeliveryValidator.checkEligiblity(zipValue, function(response) {
    // Zapiet's default "eligible" callback
    // Zapiet.DeliveryValidator.eligibleForDelivery(response);
//     console.log("JK valid!")
    MicroModal.show('mr__deliveryEligibleModal');
  }, function() {
    // Zapiet's default "not eligible" callback
    // Zapiet.DeliveryValidator.notEligibleForDelivery();
//     console.log("JK not valid!")
    MicroModal.show('mr__deliveryIneligibleModal');
  }, function() {
    // Zapiet's default error callback
    Zapiet.DeliveryValidator.error();
  });

  return false;
}

// Before submitting the "zip-lead" newsletter signup form, add the zipcode and other tags on the new customer entry
document.querySelector('#mr__deliveryIneligibleModal #contact_form #validatorZip').addEventListener('input', function (evt) {
  let thisForm = document.querySelector('#mr__deliveryIneligibleModal #contact_form');
  let zipInputValue = thisForm.validatorZip.value;
  thisForm.validatorTags.value = zipInputValue + ",zip-lead";
})

// Before submitting the welcome popup newsletter signup form, add the zipcode and other tags on the new customer entry
document.querySelector('.popup__content .contact-form #popupZip').addEventListener('input', function (evt) {
  let thisForm = document.querySelector(".popup__content .contact-form");
  let zipInputValue = thisForm.popupZip.value;
  thisForm.popupTags.value = zipInputValue + ",zip-lead";
})
